/** The Lux mark: a gold sun core held by a frame in the text colour, minted on a coin or bare next to amounts.
 * Two drawings on a 24-unit grid; MARK picks one (the owner's choice between them is this one line):
 * - "corona": ☉ (the sun, and the alchemists' gold) as a corona of four arcs, radii 6.4–10.5, cut by 2.9-wide
 *   parallel-edged gaps on the diagonals, around a core of radius 4.4.
 * - "aperture": two Ls (for Lux) closing into a diamond around a sun of radius 4.2, with one gap at the top and bottom.
 * LuxGlyph is the bare sign for amounts and menus (frame in the text colour, gold core; `mono` draws both in the text
 * colour); LuxCoin is the sign on the brand-gradient disc, at 60 % of it. The landing's gold coin draws the same mark
 * (apps/landing/index.html, .why-lux-mark). */
import { useId, type CSSProperties } from "react";

const MARKS = {
  corona: { frame: "M20.379 5.672A10.5 10.5 0 0 1 20.379 18.328L17.433 15.383A6.4 6.4 0 0 0 17.433 8.617ZM18.328 20.379A10.5 10.5 0 0 1 5.672 20.379L8.617 17.433A6.4 6.4 0 0 0 15.383 17.433ZM3.621 18.328A10.5 10.5 0 0 1 3.621 5.672L6.567 8.617A6.4 6.4 0 0 0 6.567 15.383ZM5.672 3.621A10.5 10.5 0 0 1 18.328 3.621L15.383 6.567A6.4 6.4 0 0 0 8.617 6.567Z", core: 4.4 },
  aperture: { frame: "M10.77 1.633L3.013 9.391A3.69 3.69 0 0 0 3.013 14.609L10.77 22.367L10.77 17.728L5.042 12L10.77 6.272ZM13.23 22.367L20.987 14.609A3.69 3.69 0 0 0 20.987 9.391L13.23 1.633L13.23 6.272L18.958 12L13.23 17.728Z", core: 4.2 },
};
const MARK = MARKS.aperture;
export const LUX_SUN = "#f5a524";

type Props = { size?: number | string; title?: string; className?: string; style?: CSSProperties };

export function LuxGlyph({ size = 24, title, className, style, mono }: Props & { mono?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <path fill="currentColor" d={MARK.frame} />
      <circle cx="12" cy="12" r={MARK.core} fill={mono ? "currentColor" : LUX_SUN} />
    </svg>
  );
}

export function LuxCoin({ size = 24, title, className, style }: Props) {
  const id = `lux${useId().replace(/:/g, "")}`;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0ea5ff" />
          <stop offset=".45" stopColor="#3b5bff" />
          <stop offset="1" stopColor="#7c4dff" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="12" fill={`url(#${id})`} />
      <g transform="translate(12 12) scale(.686) translate(-12 -12)">
        <path fill="#fff" d={MARK.frame} />
        <circle cx="12" cy="12" r={MARK.core} fill="#ffc861" />
      </g>
    </svg>
  );
}
